<template>
  <div>
    <div
      class="desktop"
      :class="[!isChange ? 'mainNavbarActive' : 'mainNavBarContainer']"
    >
      <div class="container">
        <div
          style="padding: 10px 0;"
          class="flex align-center justify-space-between"
        >
          <div class="flex align-center">
            <div style="position: relative; margin-right:200px">
              <img
                @click="$router.push('/')"
                class="logo mr-20"
                :src="imgs.Logo"
                alt="Logo edu"
              />
            </div>

            <div class="menu-container ml-20 mt-10">
              <Menu />
            </div>
          </div>
          <div class="flex justify-flex-end align-center mr-20">
            <div @click="$router.push('/Courses')" class="ml-20">
              <img v-if="isChange" :src="icons.SearchIcon" alt="" />
              <img v-else :src="icons.SearchBlackIcon" alt="" />
            </div>
            <!-- <div @click="$router.push('/Carts')" class="ml-20">
            <img v-if="isChange" :src="icons.CartIcon" alt="" />
            <img v-else :src="icons.CartBlackIcon" alt="" />
          </div> -->
            <div class="ml-20">
              <Avatar :is-change="isChange" v-if="getToken()" />
              <ButtonSignIn v-else :is-change="isChange" />
            </div>
          </div>
        </div>
      </div>
      <div style="position:absolute; right:20px; top:600px;z-index:1000">
        <img
          v-if="isShowScroll"
          @click="onTop"
          :src="icons.ScrollIcon"
          alt=""
        />
      </div>
    </div>
    <div class="mobile">
      <md-toolbar
        id="toolbar"
        md-elevation="0"
        class="md-transparent md-absolute bg-color"
        :class="extraNavClasses"
        :color-on-scroll="colorOnScroll"
        :style="headerImage"
      >
        <div
          style="width:100%; display: flex; justify-content: space-between; align-items: center;"
          class="md-collapse-lateral"
        >
          <div style="flex-shrink: 0;" class="md-toolbar-section-start">
            <md-button
              style="margin-right: 10px;"
              class="md-just-icon md-simple md-toolbar-toggle"
              :class="{ toggled: toggledClass }"
              @click="toggleNavbarMobile()"
            >
              <span style="color: #1565c0 !important;" class="icon-bar"></span>
              <span style="color: #1565c0 !important;" class="icon-bar"></span>
              <span style="color: #1565c0 !important;" class="icon-bar"></span>
            </md-button>
            <router-link style="display: flex; align-items: center;" to="/">
              <div style="position: relative;">
                <img
                  @click="$router.push('/')"
                  class="logo mr-20"
                  :src="imgs.Logo"
                  alt="Logo edu"
                />
              </div>
            </router-link>
          </div>
          <div class="md-toolbar-section-end">
            <div class="md-collapse">
              <div class="md-collapse-wrapper">
                <mobile-menu nav-mobile-section-start="false"> </mobile-menu>
                <md-list class="mobile">
                  <md-list-item @click="toggleNavbarMobile" href="/">
                    <el-dropdown trigger="click" @command="handleCommand">
                      <span class="el-dropdown-link">
                        <span class="text-lang">Home</span>
                      </span>
                    </el-dropdown>
                  </md-list-item>
                  <!-- <md-list-item @click="toggleNavbarMobile" to="/About">
                    <p class="text-menu">
                      About
                    </p>
                  </md-list-item> -->
                  <md-list-item @click="toggleNavbarMobile" href="/Courses">
                    <el-dropdown trigger="click" @command="handleCommand">
                      <span class="el-dropdown-link">
                        <span class="text-lang"> Courses</span>
                      </span>
                    </el-dropdown>
                  </md-list-item>
                  <!-- <md-list-item @click="toggleNavbarMobile" to="/Pages">
                    <el-dropdown trigger="click" @command="handleCommand">
                      <span class="el-dropdown-link">
                        <span class="text-lang"> Pages</span>
                        <img :src="icons.CaretIcon" alt="" />
                      </span>
                    </el-dropdown>
                  </md-list-item> -->
                </md-list>
              </div>
            </div>
          </div>
          <div
            style=" text-align: right;min-width: 180px; "
            class="md-toolbar-section-end mobile"
          >
            <div class="flex justify-flex-end align-center mr-20">
              <div @click="$router.push('/Courses')" class="ml-20">
                <img :src="icons.SearchBlackIcon" alt="" />
              </div>

              <div class="ml-20">
                <Avatar :is-change="isChange" v-if="getToken()" />
                <ButtonSignIn v-else :is-change="isChange" />
              </div>
            </div>
          </div>
        </div>
      </md-toolbar>
    </div>
  </div>
</template>

<script>
import MobileMenu from "@/layout/MobileMenu";
import Logo from "@/assets/img/logo/hocvivu logo-01 1 (3).png";
import SearchIcon from "@/assets/img/svg_edu/Search_button.svg";
import CartIcon from "@/assets/img/svg_edu/Cart.svg";
import SearchBlackIcon from "@/assets/img/svg_edu/search_btn_black.svg";
import CartBlackIcon from "@/assets/img/svg_edu/cart_btn_black.svg";
import ButtonSignIn from "@/views/components/button/ButtonSignIn.vue";
import Menu from "@/layout/Menu.vue";
import Avatar from "@/components/avatar.vue";
import ScrollIcon from "@/assets/img/svg_edu/Scroll.svg";
import { getBackGround } from "@/utils/wapAuth";
import { getToken, getInfo } from "@/utils/auth";
export default {
  components: {
    ButtonSignIn,
    Menu,
    Avatar,
    MobileMenu
  },
  props: {
    isChange: {
      type: Boolean,
      default: false
    },
    colorOnScroll: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      menus: {
        study: "Học tập",
        package: "Gói cước",
        tutor: "Gia sư",
        examination: "Thi cử",
        introduce: "Giới thiệu"
      },
      userInfo: getInfo(),
      bg: getBackGround(),
      extraNavClasses: "",
      toggledClass: false,
      admin: getToken(),
      headerImage: {
        background: getBackGround()?.headerImage
          ? `url(${getBackGround()?.headerImage})`
          : "#ECEFF8" + "!important",
        paddingTop: " 10px",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "auto",
        backgroundAttachment: "fixed",
        backgroundSize: "100% 100%"
      },
      imgs: {
        Logo
      },
      isShowScroll: false,
      icons: {
        ScrollIcon,
        SearchIcon,
        CartIcon,
        SearchBlackIcon,
        CartBlackIcon
      }
    };
  },
  created() {
    this.extraNavClasses = `md-white`;
  },
  computed: {},
  methods: {
    handleLogin() {
      this.$store.dispatch("showLoginDialog");
    },
    handleLogout() {
      window.localStorage.clear("info");
      window.location.reload();
    },
    handleRegister() {
      this.$store.dispatch("showRegisterDialog");
    },
    onTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth" // Nếu bạn muốn cuộn mượt
      });
    },
    handleScrollTop() {
      // Lấy vị trí hiện tại của cửa sổ
      const currentScrollPosition = window.scrollY;

      // Kiểm tra nếu vị trí hiện tại lớn hơn 200px từ đầu trang
      if (currentScrollPosition >= 300) {
        // Cập nhật trạng thái khi cuộn xuống
        this.isShowScroll = true;
      } else {
        // Cập nhật trạng thái khi cuộn lên trên lại top
        this.isShowScroll = false;
      }
    },

    toggleNavbarMobile() {
      this.NavbarStore.showNavbar = !this.NavbarStore.showNavbar;
      this.toggledClass = !this.toggledClass;
    },
    handleCommand(command) {},
    getToken
  },
  mounted() {
    window.addEventListener("scroll", this.handleScrollTop);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScrollTop);
  },
  beforeDestroy() {}
};
</script>

<style scoped>
.text-login-mobile {
  padding: 0;
  margin: 0;
  color: #1565c0;
  font-weight: 600;
  font-size: 17px;
}
.item-menu-active {
  border-radius: 100px;
  background: #cad9ef;
}
.item-menu:hover {
  border-radius: 100px;
  background: #cad9ef;
}
.item-menu button {
  border-radius: 100px !important;
}
.item-menu button:hover {
  border-radius: 100px;
  background: #cad9ef !important;
}
.item-menu button:hover .text-lang {
}
.btn-login {
  border-radius: 100px;
  color: #1565c0;
  border-color: #cad9ef;
}
.logo {
  position: absolute;
  max-width: 190px;
  top: -75px;
}
.mobile {
  display: none;
}
.lang-mobile {
  display: none;
}

.md-list-item .md-list-item-content p {
  color: v-bind("bg.c_menu_header");
  font-weight: 500;
}

.text-lang {
  color: #1565c0;
  padding-left: 4px;
  font-weight: 600;
  text-transform: capitalize !important;
}
.text-menu {
  color: #1565c0 !important;
  padding-left: 4px !important;
  font-weight: 600 !important;
  text-transform: capitalize !important;
  font-size: 14px !important;
}
.text-lang-item {
  padding-left: 4px;
  text-transform: uppercase;
}
.white-color {
  color: v-bind("bg.c_menu_header");
}
@media (max-width: 991px) {
  .md-collapse-lateral .md-collapse {
    position: fixed;
    display: block;
    top: 0;
    height: 100vh;
    width: 230px !important;
    left: -500px;
    z-index: 1032;
    visibility: visible;
    background-color: #1565c0;
    overflow-y: visible;
    border-top: none;
    text-align: left;
    padding-right: 0px;
    padding-left: 0;
  }
  .md-collapse-lateral .md-collapse::before {
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    position: absolute;
    display: block;
    background-color: #1565c0 !important;
    content: "";
    z-index: 1;
  }
}
@media screen and (min-width: 0px) and (max-width: 980px) {
  .text-lang {
    color: #ffff;
    font-weight: 500;
    text-transform: capitalize !important;
  }
  .text-menu {
    color: #ffff !important;
    font-weight: 500 !important;
    text-transform: capitalize !important;
    font-size: 14px !important;
  }
  .md-collapse::before {
    position: fixed;
    display: block;
    top: 0;
    height: 100vh;
    width: 230px !important;
    left: 0;
    z-index: 1032;
    visibility: visible;
    background-color: #1565c0 !important;
    overflow-y: visible;
    border-top: none;
    text-align: left;
    padding-right: 0px;
    padding-left: 0;
  }
  .lang-mobile {
    display: block;
    padding-left: 25px;
  }
  .lang-pc {
    display: none;
  }
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }

  .logo {
    position: absolute;
    max-width: 100px;
    top: -40px;
    left: -20px;
  }
}
.mainNavBarContainer {
  position: fixed;
  z-index: 1000;
  left: 0;
  right: 0;
  border-radius: 0;
}
.mainNavbarActive {
  position: fixed;
  z-index: 1000;
  left: 0;
  right: 0;
  border-radius: 0;
  border-bottom: 1px solid #035ae0;
  background: #ffff;
}

.menu-chil {
  margin-right: 30px;
}
.menu-chil p {
  color: #494949;
}
.menu-chil p:hover {
  color: #035ae0;
}
@media screen and (min-width: 0px) and (max-width: 980px) {
}
</style>
